export default function PlayIcon2() {
    return (
        <svg
            width='27'
            height='32'
            viewBox='0 0 27 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g filter='url(#filter0_b_5908_36927)'>
                <path
                    d='M0.000566363 0L27.0006 15.5885L0.000566745 31.1769L0.000566363 0Z'
                    fill='#FFFEFE'
                    fillOpacity='0.5'
                />
            </g>
            <defs>
                <filter
                    id='filter0_b_5908_36927'
                    x='-8'
                    y='-8'
                    width='43'
                    height='47.1768'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feGaussianBlur in='BackgroundImageFix' stdDeviation='4' />
                    <feComposite
                        in2='SourceAlpha'
                        operator='in'
                        result='effect1_backgroundBlur_5908_36927'
                    />
                    <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='effect1_backgroundBlur_5908_36927'
                        result='shape'
                    />
                </filter>
            </defs>
        </svg>
    );
}
